import { db } from '../firebase';
import { doc, deleteDoc } from 'firebase/firestore';
import { CATEGORIES } from '../constants';
import { getDistance } from '../utils';
import ShareButtons from './ShareButtons';

function DeleteButton({ pinId }) {
  const handleDelete = async () => {
    if (!window.confirm('이 핀을 삭제할까요?')) return;
    await deleteDoc(doc(db, 'posts', pinId));
  };
  return (
    <button
      type="button"
      onClick={handleDelete}
      style={{
        marginTop: 8, width: '100%', padding: '7px 0', borderRadius: 8,
        border: '1px solid #ffcccc', background: '#fff5f5',
        color: '#e53935', fontSize: 12, cursor: 'pointer',
      }}
    >
      🗑 핀 삭제
    </button>
  );
}

function AuthorChip({ uid, displayName, onUserClick }) {
  return (
    <button
      type="button"
      onClick={() => onUserClick(uid, displayName)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        padding: '3px 8px', borderRadius: 20, border: '1px solid #eee',
        background: '#f8f8f8', fontSize: 11, color: '#555',
        cursor: 'pointer', marginTop: 8,
      }}
    >
      👤 {displayName || '익명'}
    </button>
  );
}

export default function PopupContent({ pin, userPosition, onUserClick, currentUser }) {
  const cat = CATEGORIES[pin.category] || CATEGORIES['user'];
  const distance = userPosition
    ? getDistance(userPosition[0], userPosition[1], pin.lat, pin.lng)
    : null;

  if (pin.type === 'user') {
    return (
      <div style={{ width: 220, fontFamily: 'sans-serif' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 11, background: '#E3F2FD', color: '#1565C0', padding: '2px 8px', borderRadius: 20 }}>
            {cat.emoji} {cat.label}
          </span>
          {pin.alwaysOn && (
            <span style={{ fontSize: 11, background: '#FFF3E0', color: '#E65100', padding: '2px 8px', borderRadius: 20 }}>
              🔄 상시운영
            </span>
          )}
          {pin.isUpcoming && (
            <span style={{ fontSize: 11, background: '#F3E5F5', color: '#7B1FA2', padding: '2px 8px', borderRadius: 20 }}>
              📣 사전광고
            </span>
          )}
        </div>
        {pin.imageUrl && (
          <div style={{ width: '100%', height: 150, marginBottom: 8, borderRadius: 8, overflow: 'hidden', background: '#f0f0f0' }}>
            <img src={pin.imageUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
        )}
        <p style={{ fontSize: 13, margin: '0 0 8px', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{pin.content}</p>
        {distance && <p style={{ fontSize: 11, color: '#999', margin: 0 }}>📍 현재 위치에서 {distance}</p>}
        <AuthorChip uid={pin.uid} displayName={pin.displayName} onUserClick={onUserClick} />
        <ShareButtons pinId={pin.id} title={pin.displayName || '익명'} />
        {currentUser?.uid === pin.uid && <DeleteButton pinId={pin.id} />}
      </div>
    );
  }

  return (
    <div style={{ width: 260, fontFamily: 'sans-serif', maxHeight: 400, overflowY: 'auto' }}>
      {pin.imageUrl && (
        <div style={{ width: '100%', height: 150, marginBottom: 10, borderRadius: 8, overflow: 'hidden' }}>
          <img src={pin.imageUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
      )}
      {!pin.imageUrl && (
        <div style={{ width: '100%', height: 80, background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, marginBottom: 10, borderRadius: 8 }}>
          {cat.emoji}
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 11, background: '#E3F2FD', color: '#1565C0', padding: '2px 8px', borderRadius: 20 }}>
          {cat.emoji} {cat.label}
        </span>
        {pin.alwaysOn && (
          <span style={{ fontSize: 11, background: '#FFF3E0', color: '#E65100', padding: '2px 8px', borderRadius: 20 }}>
            🔄 상시운영
          </span>
        )}
        {pin.isUpcoming && (
          <span style={{ fontSize: 11, background: '#F3E5F5', color: '#7B1FA2', padding: '2px 8px', borderRadius: 20 }}>
            📣 사전광고
          </span>
        )}
      </div>
      <p style={{ fontSize: 15, fontWeight: 600, margin: '0 0 6px' }}>{pin.title}</p>
      {pin.eventDate && <p style={{ fontSize: 12, color: '#666', margin: '0 0 4px' }}>📅 {pin.eventDate}</p>}
      {distance && <p style={{ fontSize: 12, color: '#999', margin: '0 0 8px' }}>📍 현재 위치에서 {distance}</p>}
      <p style={{ fontSize: 13, color: '#444', margin: 0, lineHeight: 1.7, whiteSpace: 'pre-wrap' }}>{pin.content}</p>
      <AuthorChip uid={pin.uid} displayName={pin.displayName} onUserClick={onUserClick} />
      <ShareButtons pinId={pin.id} title={pin.title || 'r2z2'} />
      {currentUser?.uid === pin.uid && <DeleteButton pinId={pin.id} />}
    </div>
  );
}